import React, { FC } from 'react';
import { Grid } from '@inplayer-org/inplayer-ui';

// components
import RichLabel from 'components/RichLabel';
import RadioFieldWithInfo from 'components/Fields/RadioFieldWithInfo';

// types
import { IvsChannelVideoLatencyOption } from 'ducks/merchantDucks/items/actions';

const { Cell } = Grid;

const TooltipMessages = {
  LOW: `Under 5 seconds, best
  for near real-time`,
  NORMAL: `Under 30 seconds, enable if
  real-time is not required.`,
};

const ChannelTypeField: FC = () => (
  <Cell>
    <RichLabel>Video latency</RichLabel>
    <RadioFieldWithInfo
      tag="radiobutton_channel_latency-low"
      name="latency_mode"
      value={IvsChannelVideoLatencyOption.LOW}
      label="Ultra-low latency"
      tooltip={TooltipMessages.LOW}
    />
    <RadioFieldWithInfo
      tag="radiobutton_channel_latency-normal"
      name="latency_mode"
      value={IvsChannelVideoLatencyOption.NORMAL}
      label="Standard latency"
      tooltip={TooltipMessages.NORMAL}
    />
  </Cell>
);

export default ChannelTypeField;
